import { styled } from "@mui/material/styles";
import { Stack } from "@mui/material";

export const StyledStackContainer = styled(Stack)(() => ({
  justifyContent: "center",
  alignItems: "center",
  gap: "16px",
  margin: "16px 0",
  flexDirection: "row",
}));
